import { render, staticRenderFns } from "./RfxResponseTransitions.vue?vue&type=template&id=28cfd4d7"
import script from "./RfxResponseTransitions.vue?vue&type=script&lang=js"
export * from "./RfxResponseTransitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports